import { render, staticRenderFns } from "./vitimas.vue?vue&type=template&id=e31d09ee"
import script from "./vitimas.vue?vue&type=script&lang=js"
export * from "./vitimas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports